import { Box, styled } from "@mui/material";

export const StyledItemBox = styled(Box, {
  name: "StyledEquipmentItemBox"
})(() => ({
  marginRight: "20px",
  marginTop: "20px",
  width: "100%"
}));
